import React from "react";
import { IHocUiModuleCardBanksProps } from "../../../interfaces/props/IHocUiModuleCardBanksProps";
import { TitleStatusBank, UI_ITOModuleSubTitle } from "../../../UI_ITO/indexUI";
import { useAppDispatch, useAppSelector } from "../../../store/reduxHooks";
import {
  SELECT_APPLICATION_BANKS,
  SELECT_REQUEST_BANK,
} from "../../../store/selectors/requestAppSelector";
import { SWAP_MATCH_DATA_REQUEST_BANK_ID } from "../../../store/slice/requestAppSlise/requestAppSlise";
import { Application_banks } from "../../Chat/Types/Type";
import { BankListInApplicationInfoModal } from "../../ApplicationCreate/BankSelection/BankListInApplicationInfoModal/BankListInApplicationInfoModal";
import { STATUS_APPLICATION, USER } from "../../../types/indexTypeEnum";
import { SELECT_USER_ROLE } from "../../../store/selectors/authSliceLoginSelector";
import { plural } from "../../../utils/utilities/plural";
import { Guard } from "../../../utils/guards/Guard";
import { ApplicationBankCard } from "../ApplicationBankCard/ApplicationBankCard";

import classes from "./HocUiModuleCardBanks.module.css";
import { MATCH_DATA_APPLICATION_RENDER } from "../../../enums/matchDataApplicationRender";

const content: Record<USER, MATCH_DATA_APPLICATION_RENDER> = {
  agent: MATCH_DATA_APPLICATION_RENDER.BANK_AGENT,
  client: MATCH_DATA_APPLICATION_RENDER.BANK_CLIENT,
  "support.credit": MATCH_DATA_APPLICATION_RENDER.NOT_DATA,
  admin: MATCH_DATA_APPLICATION_RENDER.NOT_DATA,
  bank: MATCH_DATA_APPLICATION_RENDER.NOT_DATA,
  banned: MATCH_DATA_APPLICATION_RENDER.NOT_DATA,
  manager: MATCH_DATA_APPLICATION_RENDER.NOT_DATA,
};

// компонент банка на карточке заявки в списке заявок
export function HocUiModuleCardBanks(props: IHocUiModuleCardBanksProps) {
  const { setTitleBank, activeCard, changeActiveCard } = props;
  const role = useAppSelector(SELECT_USER_ROLE);

  const preferedBanks = useAppSelector(SELECT_APPLICATION_BANKS);
  const DATA_BANK_SLICE = useAppSelector(SELECT_REQUEST_BANK);
  const banks = DATA_BANK_SLICE?.filter((item) => {
    if (item.is_enabled) {
      return item;
    }
  });
  const dispatch = useAppDispatch();

  const getBankId = (item: Application_banks) => {
    changeActiveCard(item.bank.title);
    setTitleBank(
      <TitleStatusBank
        title={item.bank.title}
        status={item.status.title}
        color={item.status.color}
      />,
    );
    dispatch(
      SWAP_MATCH_DATA_REQUEST_BANK_ID({ id: item.id, value: content[role] }),
    );
  };

  return (
    <>
      <UI_ITOModuleSubTitle
        title={`Заявка направлена в ${banks.length} ${plural(banks.length, {
          one: "банк",
          few: "банка",
          many: "банков",
        })}`}
      />
      <div className={classes.cardWrapper}>
        {preferedBanks?.length > 0 && (
          <Guard.ApplicationStatus
            allowedStatuses={[
              STATUS_APPLICATION.IN_WORK,
              STATUS_APPLICATION.NEW_APPLICATION,
              STATUS_APPLICATION.TO_REWORK,
              STATUS_APPLICATION.OFFER,
            ]}
          >
            <BankListInApplicationInfoModal
              preferedBanks={preferedBanks}
              alertTitle="Предпочтительные для отправки банки."
            />
          </Guard.ApplicationStatus>
        )}

        <div className={classes.bankList}>
          {banks?.map((item, index) => {
            const isActive = activeCard === item.bank.title;
            const titleCardClasses = `${classes.titleCard}`;
            return (
              <ApplicationBankCard
                className={titleCardClasses}
                status={item.status}
                bankName={item?.bank?.title}
                onShow={() => getBankId(item as unknown as Application_banks)}
                key={index}
                isActive={isActive}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}
